import URL from '@/tools/url';
import jquery from 'jquery';
import _merge from 'lodash/merge';

export default function(options) {
  var _lang = URL.getKeyValue('lang') || '';
  var fields = { lang: _lang };
  var result = jquery.Deferred();

  if (options && options.email && options.password) {
    _merge(fields, options);
  }

  jquery.post('/client_account/session.json', fields)
    .done(function(response) {
      switch (response.status) {
        case 'error':
          result.reject(response.errors);
          break;
        default:
          result.resolve(response.client);
      }
    })
    .fail(function(response) {
      console.log('ajaxAPI: Shop: client: registration: fail', response);
      result.reject(response);
    });

  return result.promise();
}
